import type {SourceState} from "../Sources.tsx";

export const stateColors: Record<SourceState, string> = {
    "none": "#66aadd",
    "loading": "#dddd00",
    "ready": "#009900",
    "running": "#ff9900",
    "error": "#ff4444"
}